var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0002 8.00885C20.3347 8.00885 14.9308 13.4123 14.9308 20.0782C14.9308 27.0778 23.7387 36.0208 26.3061 38.4788C26.4924 38.6589 26.7413 38.7596 27.0004 38.7596C27.2595 38.7596 27.5085 38.6589 27.6947 38.4788C30.2617 36.0208 39.07 27.0778 39.07 20.0782C39.0695 13.4123 33.6657 8.00885 27.0002 8.00885ZM27.0002 24.1477C24.7525 24.1477 22.9307 22.3259 22.9307 20.0782C22.9307 17.8305 24.7525 16.0087 27.0002 16.0087C29.2479 16.0087 31.0697 17.8305 31.0697 20.0782C31.0697 22.3259 29.2479 24.1477 27.0002 24.1477Z",
    fill: "#F96619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8017 34.9532C33.1952 35.6701 32.5727 36.3732 31.9347 37.0622C33.1808 37.6197 33.9527 38.3861 33.9527 39.233C33.9527 40.9364 30.8399 42.3173 27.0006 42.3173C23.1612 42.3173 20.0484 40.9364 20.0484 39.233C20.0484 38.3861 20.8203 37.6197 22.0665 37.0622C21.4284 36.3733 20.8059 35.6702 20.1995 34.9532C16.4853 36.0032 14.0011 37.8802 14.0011 40.028C14.0002 43.3216 19.8205 45.9912 27.0001 45.9912C34.1797 45.9912 40 43.3216 40 40.028C40 37.8802 37.5158 36.0032 33.8017 34.9532Z",
    fill: "#F96619"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic_location.1125ec1f5a734b94220760535f5f6fe6.svg";
export { ForwardRef as ReactComponent };